import React from "react";
import { useNavigate } from "react-router-dom";
import {
    Sparkles,
    Users,
    GraduationCap,
    ScrollText,
} from "lucide-react";

const HomePage = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-[#05070d] text-white">
            <div className="relative overflow-hidden">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(124,58,237,0.16),transparent_36%)]" />

                <div className="relative z-10 mx-auto max-w-6xl px-6 py-8">
                    <header className="flex items-center justify-between">
                        <div>
                            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-[#d8b4fe]">
                                Liberi Curiosi
                            </p>

                            <h1 className="mt-1 font-display text-2xl text-[#ffd166]">
                                The Academy
                            </h1>
                        </div>

                        <button
                            type="button"
                            onClick={() =>
                                navigate("/plans")
                            }
                            className="
                                rounded-2xl
                                border
                                border-[#ffd166]/35
                                bg-black/60
                                px-4
                                py-2
                                text-sm
                                font-semibold
                                text-[#fff3c4]
                                transition
                                hover:border-[#ffd166]
                                hover:text-[#ffd166]
                            "
                        >
                            View Plans
                        </button>
                    </header>

                    <main className="py-20">
                        <section className="mx-auto max-w-3xl text-center">
                            <div
                                className="
                                    mx-auto
                                    flex
                                    h-20
                                    w-20
                                    items-center
                                    justify-center
                                    rounded-full
                                    border
                                    border-[#ffd166]/55
                                    bg-[#2b1548]/70
                                    text-[#ffd166]
                                    shadow-[0_0_30px_rgba(168,85,247,0.30)]
                                "
                            >
                                <Sparkles size={34} />
                            </div>

                            <p className="mt-7 text-xs font-semibold uppercase tracking-[0.3em] text-[#d8b4fe]">
                                Homeschool, reimagined
                            </p>

                            <h2 className="mt-4 font-display text-5xl leading-tight text-[#ffd166] md:text-6xl">
                                A living academy for curious minds
                            </h2>

                            <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-[#b0b8d6]">
                                Liberi Curiosi brings planning, classrooms,
                                student work, progress, and imaginative
                                learning into one connected homeschool
                                experience.
                            </p>

                            <div className="mt-10 grid gap-4 sm:grid-cols-3">
                                <button
                                    type="button"
                                    onClick={() =>
                                        navigate(
                                            "/parent/login"
                                        )
                                    }
                                    className="
                                        flex
                                        items-center
                                        justify-center
                                        gap-3
                                        rounded-2xl
                                        border
                                        border-[#ffd166]/50
                                        bg-[#2b1548]/70
                                        px-5
                                        py-4
                                        font-semibold
                                        text-[#fff3c4]
                                        shadow-[0_0_22px_rgba(168,85,247,0.18)]
                                        transition
                                        hover:border-[#ffd166]
                                        hover:text-[#ffd166]
                                    "
                                >
                                    <Users size={19} />
                                    Parent Sign In
                                </button>

                                <button
                                    type="button"
                                    onClick={() =>
                                        navigate(
                                            "/child/login"
                                        )
                                    }
                                    className="
                                        flex
                                        items-center
                                        justify-center
                                        gap-3
                                        rounded-2xl
                                        border
                                        border-[#c084fc]/40
                                        bg-[#160d26]/55
                                        px-5
                                        py-4
                                        font-semibold
                                        text-[#e9d5ff]
                                        transition
                                        hover:border-[#c084fc]
                                        hover:bg-[#2b1548]/60
                                    "
                                >
                                    <GraduationCap size={19} />
                                    Child Sign In
                                </button>

                                <button
                                    type="button"
                                    onClick={() =>
                                        navigate("/plans")
                                    }
                                    className="
                                        flex
                                        items-center
                                        justify-center
                                        gap-3
                                        rounded-2xl
                                        border
                                        border-[#ffd166]/30
                                        bg-black/70
                                        px-5
                                        py-4
                                        font-semibold
                                        text-[#fff3c4]
                                        transition
                                        hover:border-[#ffd166]
                                    "
                                >
                                    <ScrollText size={19} />
                                    View Plans
                                </button>
                            </div>
                        </section>

                        <section className="mt-20 grid gap-6 md:grid-cols-3">
                            <div className="rounded-[28px] border border-[#ffd166]/25 bg-black/70 p-6">
                                <h3 className="font-display text-2xl text-[#ffd166]">
                                    For Parents
                                </h3>

                                <p className="mt-3 text-sm leading-relaxed text-[#b0b8d6]">
                                    Plan the year, organize classes, assign
                                    work, review progress, and guide each
                                    student from one parent portal.
                                </p>
                            </div>

                            <div className="rounded-[28px] border border-[#c084fc]/25 bg-[#160d26]/45 p-6">
                                <h3 className="font-display text-2xl text-[#e9d5ff]">
                                    For Students
                                </h3>

                                <p className="mt-3 text-sm leading-relaxed text-[#c4b5d8]">
                                    Enter a classroom built around lessons,
                                    quests, notebooks, whiteboards, and the
                                    work that belongs to each class.
                                </p>
                            </div>

                            <div className="rounded-[28px] border border-[#ffd166]/20 bg-black/70 p-6">
                                <h3 className="font-display text-2xl text-[#ffd166]">
                                    One Connected School
                                </h3>

                                <p className="mt-3 text-sm leading-relaxed text-[#b0b8d6]">
                                    Parent and child views stay connected so
                                    schedules, assignments, and classroom
                                    work belong to the same school system.
                                </p>
                            </div>
                        </section>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default HomePage;